<template>
    <div id="message" class="messagebox" :class="[type, size]">
        {{text}}
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: "Message",
    props: {
            text: {
                type: String,
                required: false,
                default: "",
            },
            type: {
                teype: String,
                default: "log"
            },
            size: {
                teype: String,
                default: "l"
            }
    },
    methods:{
    },
    computed:{
    },
    components: {
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .messagebox {
        
        text-align: center;
        vertical-align: middle;
        border-radius: $border_radius_default;  
        font-weight: bold;     
    }

    .l {
        padding:$height_default;
    }

    .s {
        padding:$spacer_s;
    }

    .xs {
       padding:$spacer_xs; 
    }

    .log {
        background-color:rgba($seltec_color, 0.3);
    }

    .warning {
        background-color:rgba($seltec_color, 0.7);
    }

    .error {
        background-color:rgba($prim_aleart_color_dark, 0.7);
    }

    .success {

    }

    .hint {
        background-color:rgba($prim_hint_color, 0.3);
    }

</style>